import React, { Component } from 'react';
import TextInput from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES } from 'utils/CommonConstants';
import { RESOLUTIONS as BREAKPOINTS } from 'services/config';
import { TICKET_ATTACHMENT_PHASE as PHASE } from 'utils/TicketConstants';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const LowPrioritySelected = `${CDN_URL}support/ticketing/low-priority-selected-lg.svg`;
const MediumPrioritySelected = `${CDN_URL}support/ticketing/medium-priority-selected-lg.svg`;
const HighPrioritySelected = `${CDN_URL}support/ticketing/high-priority-selected-lg.svg`;

const MAX_TEXT_AREA_HEIGHT = {
	[BREAKPOINTS.LOW]: 104,
	[BREAKPOINTS.MED]: 180,
	[BREAKPOINTS.HIGH]: 272,
};
class IssueDescriptionEdit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			description: '',
			attachmentModalOpen: false,
			attachments: [],
			attachmentErrors: [],
			phase: PHASE.NOT_STARTED,
		};
	}
	getImage = priority => {
		if (priority === 'low') {
			return LowPrioritySelected;
		} else if (priority === 'high') {
			return HighPrioritySelected;
		} else {
			return MediumPrioritySelected;
		}
	};
	onChange = event => {
		const { updateData } = this.props;
		this.setState({ [event.target.name]: event.target.value });
		updateData('issue', event.target.name, event.target.value);
	};

	componentDidMount() {
		const { data } = this.props;
		if (data.issue && data.issue.description) {
			this.setState({ description: data.issue.description });
		}
	}

	render() {
		const { data, breakpoint } = this.props;
		const { description } = this.state;
		const priority = data.priority ? data.priority : 'MEDIUM';
		return (
			<div className='issue-description-container edit'>
				<div className='issue-description-section'>
					<div className={`priority ${priority}`}>
						<div className='icon'>
							<img src={this.getImage(priority)} />
						</div>
						<div className='priority-level'>
							<div className='text buttons10'>{`${priority} PRIORITY`}</div>
						</div>
					</div>

					<TextInput
						placeholder='Please be as descriptive as possible.'
						type={INPUT_TYPES.TEXTAREA}
						label='ISSUE Description'
						name='description'
						value={data.description ? data.description : description || ''}
						onChange={this.onChange}
						characterMinLength={50}
						showCharacterCount={true}
						active={true}
						setDefaultValueAsPlaceholder
						minMessage={true}
						maxTextAreaHeight={MAX_TEXT_AREA_HEIGHT[breakpoint]}
					/>
				</div>
			</div>
		);
	}
}

export default IssueDescriptionEdit;
